module.exports = __webpack_public_path__ + "static/Aim-99df4ac77f58c3ab00cbdfef4cf040ee.jpg";